"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVerified = useVerified;
const viemConnector_1 = require("../ethereum/viemConnector");
function useVerified(args) {
    const { isVerified } = (0, viemConnector_1.viemConnector)({ rpcUrl: args.rpcUrl });
    return { isVerified };
}
